<template>
  <div class="__PreferencesDialogFilter">
    <CInputNumber
      width="160px"
      :label="$t('Default number of series')"
      v-model="currentDefaultSeriesCount"
      :max="200"
      :min="1"
    />

    <!--<CTitle lighter class="mb-xs">-->
    <!--  {{ $t('デフォルトで選択するシリーズ') }}-->

    <!--  <template v-slot:subtitle>-->
    <!--    <span-->
    <!--      :class="{-->
    <!--        '__PreferencesDialogFilter-alertMessage':-->
    <!--          currentDefaultSeries.length >= currentDefaultSeriesCount,-->
    <!--      }"-->
    <!--    >-->
    <!--      {{ $t('You can select up to {count}.', { count: currentDefaultSeriesCount }) }}-->
    <!--    </span>-->
    <!--  </template>-->
    <!--</CTitle>-->

    <!--<CSelector-->
    <!--  class="mb-md"-->
    <!--  v-model="currentCategory"-->
    <!--  :options="categoryOptions"-->
    <!--  :use-input="false"-->
    <!--  emit-value-->
    <!--  map-options-->
    <!--/>-->

    <!--<PreferencesDialogFilterSeriesList-->
    <!--  v-model="currentDefaultSeries"-->
    <!--  :category="currentCategory"-->
    <!--  :max="currentDefaultSeriesCount"-->
    <!--/>-->
  </div>
</template>

<script>
import Vue from 'vue';

// Chart common lang
import chartLang from '@/components/CustomCharts/lang';

import CRow from '@/components/uikit/CRow';
import CCol from '@/components/uikit/CCol';
import CTitle from '@/components/uikit/CTitle';
import CInputNumber from '@/components/uikit/CInputNumber';
import CSelector from '@/components/uikit/CSelector';
import PreferencesDialogFilterSeriesList from '@/components/CustomCharts/PreferencesDialogFilterSeriesList';

const messages = {
  en: {
    // Chart common lang
    ...chartLang.en,

    'Default number of series': 'Default number of series',
    'You can select up to {count}.': 'You can select up to {count}.',
  },
  ja: {
    // Chart common lang
    ...chartLang.ja,

    'Default number of series': 'デフォルトのシリーズ数',
    'You can select up to {count}.': '最大{count}つまで選択できます。',
  },
};

export default Vue.extend({
  name: 'PreferencesDialogFilter',
  i18n: { messages },
  components: { CRow, CCol, CTitle, CInputNumber, CSelector, PreferencesDialogFilterSeriesList },
  props: {
    defaultSeriesCount: {
      type: Number,
    },
    defaultSeries: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentCategory: 'service',
      categoryOptions: [
        { label: this.$t('service'), value: 'service' },
        { label: this.$t('account'), value: 'account' },
      ],
    };
  },
  computed: {
    currentDefaultSeriesCount: {
      get() {
        return this.defaultSeriesCount;
      },
      set(val) {
        this.$emit('update:defaultSeriesCount', val);
      },
    },

    currentDefaultSeries: {
      get() {
        return this.defaultSeries[this.currentCategory]
          ? this.defaultSeries[this.currentCategory]
          : [];
      },
      set(val) {
        const series = this.defaultSeries;
        series[this.currentCategory] = val;

        this.$emit('update:defaultSeries', series);
      },
    },
  },
});
</script>

<style lang="scss" scoped>
.__PreferencesDialogFilter {
  &-alertMessage {
    color: $danger-color;
    font-weight: $font-weight-bold;
  }
}
</style>
